var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelebration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 47.5 47.5",
    viewBox: "0 0 47.5 47.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dd2e44",
    d: "M0 0a1.413 1.413 0 0 1-.268-.395l-.008.008-11.216-25.265.011-.011c-.208-.403.14-1.223.853-1.937.712-.712 1.532-1.06 1.935-.852l.01-.01 25.267 11.215-.008.009c.148.07.282.155.395.268 1.562 1.562-.971 6.627-5.657 11.313C6.628-.97 1.562 1.562 0 0",
    transform: "translate(12.626 29.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea596e",
    d: "m0 0-12.584-20.506-.282-.635.011-.01c-.208-.404.14-1.223.853-1.937a3.97 3.97 0 0 1 .709-.557L4-5 0 0Z",
    transform: "translate(14 25)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0041e",
    d: "M0 0c4.67-4.672 7.263-9.652 5.789-11.125-1.473-1.473-6.453 1.119-11.126 5.789-4.671 4.672-7.263 9.653-5.79 11.127C-9.653 7.264-4.673 4.671 0 0",
    transform: "translate(24.012 23.934)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa8dd8",
    d: "M0 0a.99.99 0 0 0-.734-.215c-.868.094-1.598.396-2.109.873-.541.505-.808 1.182-.735 1.862.128 1.192 1.324 2.286 3.363 2.065.793-.085 1.147.17 1.158.292.014.121-.277.446-1.069.532-.869.094-1.598.396-2.11.873-.541.505-.809 1.183-.735 1.862.13 1.192 1.325 2.286 3.362 2.065.578-.062.882.058 1.011.135.104.063.145.123.149.157.011.121-.276.446-1.071.532a1 1 0 0 0 .215 1.988c2.037-.219 2.973-1.542 2.844-2.735C3.41 9.094 2.215 8.001.176 8.221c-.578.063-.881-.057-1.01-.134-.103-.063-.145-.124-.149-.157-.013-.122.276-.447 1.071-.533 2.037-.219 2.973-1.542 2.844-2.735C2.803 3.47 1.607 2.376-.43 2.597c-.578.062-.882-.057-1.012-.134-.103-.063-.143-.124-.147-.158-.013-.121.276-.446 1.07-.532A.998.998 0 0 0 0 0",
    transform: "translate(19.59 23.39)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77b255",
    d: "M0 0c1.973.557 3.334-.323 3.658-1.478.324-1.154-.378-2.615-2.349-3.169-.77-.216-1.001-.584-.97-.702.034-.118.425-.312 1.193-.094 1.972.554 3.333-.326 3.657-1.48.327-1.155-.377-2.614-2.35-3.17-.769-.216-1.001-.585-.967-.702.033-.117.423-.31 1.192-.095a1 1 0 1 0 .54-1.925c-1.97-.555-3.333.323-3.659 1.479-.324 1.154.379 2.613 2.353 3.169.769.217 1.001.584.967.702-.033.117-.422.312-1.191.096-1.973-.556-3.334.322-3.659 1.478-.325 1.155.378 2.614 2.352 3.17.767.215.999.585.966.701-.034.119-.422.313-1.192.096A1 1 0 1 0 0 0",
    transform: "translate(31.661 14.143)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa8dd8",
    d: "M0 0a1.001 1.001 0 0 0-.626 1.781c.218.175 5.418 4.259 12.767 3.208a.999.999 0 0 0 .848-1.131.995.995 0 0 0-1.132-.848C5.364 3.932.67.256.624.219A.994.994 0 0 0 0 0",
    transform: "translate(24.001 16.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77b255",
    d: "M0 0a1 1 0 0 0-.958 1.288c1.133 3.773 2.16 9.794.898 11.363-.142.178-.354.353-.842.316-.939-.071-.849-2.051-.848-2.071a1 1 0 1 0-1.994-.149c-.104 1.379.326 4.035 2.691 4.214 1.056.08 1.933-.287 2.553-1.057C3.871 10.953 1.464 2.397.957.712A1 1 0 0 0 0 0",
    transform: "translate(6.754 21)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c913b",
    d: "M0 0a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 0 0",
    transform: "translate(28 27.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9266cc",
    d: "M0 0a2 2 0 1 0-4.001.001A2 2 0 0 0 0 0",
    transform: "translate(5 19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c913b",
    d: "M0 0a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 0 0",
    transform: "translate(35 17.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c913b",
    d: "M0 0a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 0 0",
    transform: "translate(26 5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M0 0a2 2 0 1 0-4.001.001A2 2 0 0 0 0 0",
    transform: "translate(31 33)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M0 0a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 0 0",
    transform: "translate(35 28.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M0 0a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 0 0",
    transform: "translate(32 24.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M0 0a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 0 0",
    transform: "translate(10 13.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.902d15e7c4118f1de8a1a0ffc19ee522.svg";
export { ForwardRef as ReactComponent };